/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EditorDocTemplateType {
    NARRATIVE = 'narrative',
    SWITCHBOARD = 'switchboard',
    REFRESH = 'refresh',
}
